import React from 'react';
import { useBuild } from '../../contexts/BuildContext';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'updated_at', label: 'updated_at' },
  { id: 'last_trade_time', label: 'last_trade_time' },
  { id: 'pnl', label: 'pnl' },
  { id: 'volume_quote', label: 'volume_quote' },
  { id: 'volume_outcome', label: 'volume_outcome' },
  { id: 'markets_traded', label: 'markets_traded' },
  { id: 'events_per_day', label: 'events_per_day' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'user_ids', label: 'User IDs' },
  { id: 'ai_labels2', label: 'AI Labels' },
  { id: 'tags2', label: 'Tags' },
  { id: 'is_null', label: 'Is Null' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const KalshiWalletsQuery = () => {
  const { selectedIndex } = useBuild();
  return (
    <QueryModes
      source={selectedIndex}
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default KalshiWalletsQuery;
